import React, { useState, useCallback } from "react";

import queryString from "query-string";

import ReportService from "../../../services/reportService";

import { downloadCSV } from "../utils";

import { formatDate } from "../../../helpers/date";

import ProjectProgressFilters from "./ProjectProgressFilters";

import ProjectProgressList from "./ProjectProgressList";

import { PROJECT_PROGRESS_COLUMNS } from "./columns";

import "./ProjectProgressPage.scss";

const ProjectProgressPage = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setData([]);
    const query = queryString.stringify(filters, { arrayFormat: "bracket" });
    const result = await ReportService.get(`/project-progress?${query}`);
    setData(result);
    setLoading(false);
  }, [filters]);

  const handleChange = (name) => (value) => {
    setLoading(false);
    if (
      Array.isArray(value) &&
      (name === "departments" ||
        name === "customers" ||
        name === "callTypes" ||
        name === "projects" ||
        name === "categories" ||
        name === "statuses" ||
        name === "managers")
    ) {
      setFilters((prev) => ({ ...prev, [name]: value.map((v) => v.value) }));
    } else {
      setFilters((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleExport = () => {
    downloadCSV(
      `ProjectProgress-${formatDate(new Date(), "yyyyMMdd")}`,
      data,
      PROJECT_PROGRESS_COLUMNS,
      "Project Progress"
    );
  };

  const handleResetFilters = () => {
    setFilters({});
    setData([]);
  };

  return (
    <div id="project-progress-page" className="report-page">
      <ProjectProgressFilters
        filters={filters}
        onChange={handleChange}
        onCSVExport={handleExport}
        exportDisabled={loading || !data?.length}
        onFetchClick={fetchData}
        onResetClick={handleResetFilters}
        disabled={loading || !filters.customers}
      />
      <ProjectProgressList data={data} loading={loading} />
    </div>
  );
};

export default ProjectProgressPage;
